import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { UserPersonalDataModel } from '../../../models/user/userPersonalDataModel';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import UserPersonalDataService from '../../../services/userPersonalDataService';
import AuthService from '../../../services/authService';
import Growl from '../../../common/components/alertMessage/growl';
import { ProfessionType, PregnancyType, BloodType, GenderType } from "../../../common/enums";
import { DropdownModel } from "../../../models/dropdownModel";
import { enumToDropdownArray } from '../../../common/functions/helperFunctions';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { DatePicker } from '@material-ui/pickers';
import { Checkbox } from '@material-ui/core';
import * as Constants from '../../../common/constants';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { id } from "date-fns/esm/locale";

interface IProps {
  history: any;
  userId?: number;
  onCancelClick: any;
  onSave?: any;
}

interface IState {
  isLoading: boolean;
  userPersonalData: UserPersonalDataModel;
  professionTypeDropdown: Array<DropdownModel>;
  pregnancyTypeDropdown: Array<DropdownModel>;
  bloodTypeDropdown: Array<DropdownModel>;
  genderTypeDropdown: Array<DropdownModel>;
  //isBirtdateDisabled: boolean;
}

class UserPersonalDataTab extends React.Component<IProps, IState> {

  userPersonalDataService = new UserPersonalDataService();
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      userPersonalData: new UserPersonalDataModel(),
      professionTypeDropdown: new Array<DropdownModel>(0),
      pregnancyTypeDropdown: new Array<DropdownModel>(0),
      bloodTypeDropdown: new Array<DropdownModel>(0),
      genderTypeDropdown: new Array<DropdownModel>(0),
      //isBirtdateDisabled: true
    };
  }

  componentDidMount() {
    let userId = this.props.userId ? this.props.userId : this.authService.getUserId();

    const professionTypeDropdown: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];
    const pregnancyTypeDropdown: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];
    const bloodTypeDropdown: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];
    const genderTypeDropdown: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];

    if (this.authService.isAuthenticated()) {

      this.setState({
        isLoading: true,
        professionTypeDropdown: professionTypeDropdown.concat(enumToDropdownArray(ProfessionType, true)),
        pregnancyTypeDropdown: pregnancyTypeDropdown.concat(enumToDropdownArray(PregnancyType, true)),
        bloodTypeDropdown: bloodTypeDropdown.concat(enumToDropdownArray(BloodType, true)),
        genderTypeDropdown: genderTypeDropdown.concat(enumToDropdownArray(GenderType, true))
      });

      this.userPersonalDataService.getUserPersonalData(userId).then(
        (data: UserPersonalDataModel) => {
          if (data) {
            this.setState({
              isLoading: false,
              userPersonalData: data,
              //isBirtdateDisabled: data.birthDate == undefined
            });
          }
        })
        .catch(error => {
          this.growl.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        });
    }
  }

  handleChange = (key, value) => {
    const userPersonalData: UserPersonalDataModel = { ...this.state.userPersonalData };
    if (key == "genderTypeId" && value == GenderType.Male) {
      userPersonalData.pregnancyTypeId = undefined;
    }
    userPersonalData[key] = value;
    this.setState({ userPersonalData: { ...userPersonalData } });
  };

  // handleBirtdateCheckbox = () => {
  //   this.setState({
  //     isBirtdateDisabled: !this.state.isBirtdateDisabled
  //   });
  //   if (this.state.isBirtdateDisabled) {
  //     this.handleChange('birthDate', this.state.userPersonalData.birthDate ? this.state.userPersonalData.birthDate : new Date().toISOString());
  //   }
  // }

  handleSaveButton = event => {
    event.preventDefault();

    //if (!this.isValidAddEditForm()) return;

    this.setState({
      isLoading: true
    });

    const { userPersonalData } = this.state;

    // if (userPersonalData && userPersonalData.birthDate) {
    //   userPersonalData.birthDate = !isBirtdateDisabled ? HelperFunctions.fomatDateAsString(new Date(userPersonalData.birthDate)) : undefined
    // }

    this.userPersonalDataService.updateUserPersonalData(userPersonalData).then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false
          });
          this.growl.show({ severity: 'success', summary: Translate('You have successfully saved your data.') });
          this.props.onSave();
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });

  }

  isValidAddEditForm() {
    let message = '';

    const { userPersonalData } = this.state;

    // if (!user.email || user.email.trim() == '') {
    //   message += Translate('Please enter Email') + '.<br />';
    // } else {
    //   if (!HelperFunctions.validateEmail(this.state.user.email)) {
    //     message += Translate('Please enter valid Email') + '.<br />';
    //   }
    // }

    message ? this.growl.show({ severity: 'error', summary: message }) : null;

    return message == '';
  }

  clearDate = (e) => {
    if (e) {
      e.preventDefault();
    }
    let userPersonalData = { ...this.state.userPersonalData }
    userPersonalData.birthDate = undefined;
    this.setState({ userPersonalData: userPersonalData });
  }

  public render() {
    const { isLoading, userPersonalData,
      genderTypeDropdown, professionTypeDropdown, pregnancyTypeDropdown, bloodTypeDropdown } = this.state;

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <div>
          <div className="p-grid p-fluid p-md-12">
            <div className="p-col-12 p-md-3">
              <InputLabel htmlFor="birth-label">{Translate('Birthdate')}</InputLabel>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <DatePicker
                  format={Translate('DateFormat')}
                  margin="none"
                  value={userPersonalData.birthDate ? new Date(userPersonalData.birthDate) : null}
                  onChange={(e) => this.handleChange('birthDate', e)}
                  placeholder={Translate('Enter birht date')}
                  inputProps={{
                    id: 'birth-label'
                  }}
                />
                <div style={{ padding: 5 }}>
                  <a href='' onClick={(e) => this.clearDate(e)} >
                    <FontAwesomeIcon icon={faTimes} style={{ color: '#808080', fontSize: '1.3em', margin: '0 2px' }} />
                  </a>
                </div>
              </div>
            </div>

            <div className="p-col-12 p-md-3">
              <FormControl>
                <InputLabel htmlFor="gender-label">{Translate('Gender')}</InputLabel>
                <Select
                  value={userPersonalData.genderTypeId ? userPersonalData.genderTypeId : ''}
                  onChange={(e) => this.handleChange('genderTypeId', e.target.value)}
                  inputProps={{
                    id: 'gender-label'
                  }}
                >
                  {
                    genderTypeDropdown.map(m => <MenuItem key={m.value + 'gender'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                  }
                </Select>
              </FormControl>
            </div>

            <div className="p-col-12 p-md-3">
              <FormControl>
                <InputLabel htmlFor="blood-type-label">{Translate('Blood Type')}</InputLabel>
                <Select
                  value={userPersonalData.bloodTypeId ? userPersonalData.bloodTypeId : ''}
                  onChange={(e) => this.handleChange('bloodTypeId', e.target.value)}
                  inputProps={{
                    id: 'blood-type-label'
                  }}
                >
                  {
                    bloodTypeDropdown.map(m => <MenuItem key={m.value + 'blood-type'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                  }
                </Select>
              </FormControl>
            </div>

            <div className="p-col-12 p-md-3">
              <TextField
                autoComplete="off"
                name="height"
                label={Translate('Height (cm)')}
                type="number"
                value={userPersonalData.height ? userPersonalData.height : ''}
                onChange={(e) => this.handleChange('height', e.target.value)}
              />
            </div>

            <div className="p-col-12 p-md-3">
              <TextField
                autoComplete="off"
                name="weight"
                label={Translate('Weight (kg)')}
                type="number"
                value={userPersonalData.weight ? userPersonalData.weight : ''}
                onChange={(e) => this.handleChange('weight', e.target.value)}
              />
            </div>


            <div className="p-col-12 p-md-3">
              <FormControl>
                <InputLabel htmlFor="profession-type-label">{Translate('Profession')}</InputLabel>
                <Select
                  value={userPersonalData.professionTypeId ? userPersonalData.professionTypeId : ''}
                  onChange={(e) => this.handleChange('professionTypeId', e.target.value)}
                  inputProps={{
                    id: 'profession-type-label'
                  }}
                >
                  {
                    professionTypeDropdown.map(m => <MenuItem key={m.value + 'profession-type'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                  }
                </Select>
              </FormControl>
            </div>
            {userPersonalData.genderTypeId && userPersonalData.genderTypeId == GenderType.Female ?
              <div className="p-col-12 p-md-3">
                <FormControl>
                  <InputLabel htmlFor="pregnancy-type-label">{Translate('Pregnancy&Breastfeeding')}</InputLabel>
                  <Select
                    value={userPersonalData.pregnancyTypeId ? userPersonalData.pregnancyTypeId : ''}
                    onChange={(e) => this.handleChange('pregnancyTypeId', e.target.value)}
                    inputProps={{
                      id: 'pregnancy-type-label'
                    }}
                  >
                    {
                      pregnancyTypeDropdown.map(m => <MenuItem key={m.value + 'pregnancy-type'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                    }
                  </Select>
                </FormControl>
              </div> : null}

            <div className="p-col-12">
              <TextField
                autoComplete="off"
                name="notAllowedFoods"
                label={Translate('Not allowed food and drinks')}
                value={userPersonalData.notAllowedFoods ? userPersonalData.notAllowedFoods : ''}
                onChange={(e) => this.handleChange('notAllowedFoods', e.target.value)}
              />
            </div>

            <div className="p-col-12">
              <TextField
                autoComplete="off"
                name="allergies"
                label={Translate('Allergies')}
                value={userPersonalData.allergies ? userPersonalData.allergies : ''}
                onChange={(e) => this.handleChange('allergies', e.target.value)}
              />
            </div>

          </div>
          <div style={{ textAlign: 'right', padding: '10px 9px' }}>
            <Button variant="contained" size="small" onClick={this.props.onCancelClick} style={{ marginRight: '10px' }}>
              <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
              {Translate('Cancel')}
            </Button>
            <Button variant="contained" size="small" color="primary" onClick={this.handleSaveButton}>
              <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
              {Translate('Save')}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default UserPersonalDataTab;